
import { useTranslation } from 'react-i18next';

const Footer = ({ lang, datos }) => {

    const { t } = useTranslation();

    var currentTime = new Date();
    var year = currentTime.getFullYear();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Hace el salto más suave.
        });
    };

    return (
        <>
            <footer className="u-align-center u-clearfix u-container-align-center u-footer u-white" id="footer">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-sheet-1">
                    <p className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-small-text u-text u-text-variant u-text-1" data-animation-name="" data-animation-duration="0" data-animation-delay="0" data-animation-direction="" style={{ lineHeight: "inherit" }}>
                        <a href={"/" + preidioma + t("contacto")}>{t("Contacto")}</a><br />
                        <a href={"/" + preidioma + t("sobre-nosotros")}>{t("Sobre Nosotros")}</a><br />
                        <a href={"/" + preidioma + t("clientes")}>{t("Clientes")}</a><br />
                        <a href={"/" + preidioma + t("armadores")}>{t("Armadores y Agencias")}</a><br />
                        <a href={"/" + preidioma + "faqs"}>{t("Faq's")}</a><br />
                        <a href={"/" + preidioma + t("blog")}>{t("Blog")}</a><br />
                        <a href={"/" + preidioma + t("terminos")}>{t("Términos")}</a><br />
                        <a href={"/" + preidioma + t("politica-de-cancelacion")}>{t("Política de Cancelación")}</a><br />
                        <a href={"/" + preidioma + t("politica-de-privacidad")}>{t("Política de privacidad")}</a><br />
                        <a href={"/" + preidioma + t("legal")}>{t("Aviso Legal")}</a><br />
                        <a href={"/" + preidioma + t("cookies")}>{t("Política de Cookies")}</a><br />
                    </p>
                    <p className="u-align-center-xs u-align-left-lg u-align-left-xl u-align-right-md u-align-right-sm u-small-text u-text u-text-variant u-text-2" style={{ lineHeight: "inherit" }}>
                        {datos.nombre_comercial}<br />
                        {datos.nombre_fiscal}<br />
                        {datos.direccion_fiscal}<br />
                        {datos.codigo_postal_fiscal + " " + datos.poblacion_fiscal}<br />
                        {datos.nif_fiscal} - ©&nbsp;{year}<br />
                    </p>
                    <img className="u-align-center-md u-align-center-sm u-align-center-xs u-image u-image-contain u-image-default u-image-1" src="/images/web/onboard2/00-ON BOARD LOGO-2025.png" alt="" data-image-width="4583" data-image-height="2111" data-href="./" data-page-id="98069077" title="Casa" />
                    <p className="u-align-left-lg u-align-left-xl u-align-left-xs u-align-right-md u-align-right-sm u-small-text u-text u-text-variant u-text-3" style={{ lineHeight: "inherit" }}>{t("Síguenos en​ redes sociales para más inspiración")}</p>
                    <div className="u-social-icons u-social-icons-1">
                        <a className="u-social-url" title="instagram" target="_blank" href={datos.url_instagram}>
                            <span className="u-icon u-social-icon u-social-instagram u-text-black u-icon-1">
                                <svg className="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112">
                                    <use xlinkHref="#svg-efcb"></use>
                                </svg>
                                <svg className="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-efcb">
                                    <path fill="currentColor" d="M55.9,32.9c-12.8,0-23.2,10.4-23.2,23.2s10.4,23.2,23.2,23.2s23.2-10.4,23.2-23.2S68.7,32.9,55.9,32.9z M55.9,69.4c-7.4,0-13.3-6-13.3-13.3c-0.1-7.4,6-13.3,13.3-13.3s13.3,6,13.3,13.3C69.3,63.5,63.3,69.4,55.9,69.4z"></path>
                                    <path fill="currentColor" d="M78.2,11H33.5C21,11,10.8,21.3,10.8,33.7v44.7c0,12.6,10.2,22.8,22.7,22.8h44.7c12.6,0,22.7-10.2,22.7-22.7 V33.7C100.8,21.1,90.6,11,78.2,11z M91,78.4c0,7.1-5.8,12.8-12.8,12.8H33.5c-7.1,0-12.8-5.8-12.8-12.8V33.7 c0-7.1,5.8-12.8,12.8-12.8h44.7c7.1,0,12.8,5.8,12.8,12.8V78.4z"></path>
                                </svg>
                            </span>
                        </a>
                    </div>
                </div>
            </footer>
            <span style={{ height: "64px", width: "64px", marginLeft: "0px", marginRight: "auto", marginTop: "0px", backgroundImage: "none", right: "70px", bottom: "70px", padding: "20px" }} className="u-back-to-top u-custom-color-5 u-icon u-icon-circle u-opacity u-opacity-85" data-href="#" onClick={handleClick}>
                <svg className="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 551.13 551.13">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-1d98"></use>
                </svg>
                <svg className="u-svg-content" enableBackground="new 0 0 551.13 551.13" viewBox="0 0 551.13 551.13" xmlns="http://www.w3.org/2000/svg" id="svg-1d98">
                    <path d="m275.565 189.451 223.897 223.897h51.668l-275.565-275.565-275.565 275.565h51.668z"></path>
                </svg>
            </span>
        </>
    );
};
export default Footer;
